// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VDIvC","questions":"styles_questions__3TA4M","footer":"styles_footer__uyOY9"};